<template>
  <DragDialog
    title="地图配置"
    :width="1200"
    :visible.sync="visible"
    :footerBtn="footerBtn"
    :submit="submit"
    :cancel="cancel">
    <div class="wmts-map-box">
      <div class="service-box">
        <MapServiceList
          v-show="currMode === 'serviceList'"
          ref="mapServiceList"
          :updateCurrMode="updateCurrMode"
          :currMapServiceInfo="currMapServiceInfo"
          :updateCurrMapServiceInfo="updateCurrMapServiceInfo" />
        <NewService
          ref="newService"
          v-show="isNewServiceVisible()"
          :currMode="currMode"
          :updateCurrMode="updateCurrMode"
          :resetSeniorParams="resetSeniorParams"
          :currMapServiceInfo="currMapServiceInfo" />
        <div class="service-preview-box">
          <p class="header">服务预览</p>
          <div
            v-show="currMapServiceInfo.layerResType !== 'height'"
            class="content-box">
            <div
              id="mapbox-map"
              class="map-container"></div>
            <div
              class="service-form-box"
              v-if="isCoverageVisible()">
              <div class="common-checkbox-box">
                <el-checkbox
                  class="checkbox-primary"
                  @change="checkboxChange"
                  v-model="bboxForm.enableCoverage">
                  启用有效区域限制
                </el-checkbox>
              </div>
              <div class="effective-coverage-input-box">
                <div class="compass-box">
                  <div class="compass-outer-circle">
                    <img :src="require('@/assets/icon/compass.png')" />
                  </div>
                </div>
                <el-form
                  ref="bboxForm"
                  :model="bboxForm"
                  :rules="rules">
                  <div class="effective-top-box">
                    <el-form-item prop="effectiveCoverageTop">
                      <div class="common-input-box">
                        <el-input
                          class="input-outerborder-primary"
                          size="small"
                          @change="value => inputChange('top', value)"
                          v-model="bboxForm.effectiveCoverageTop">
                          <template slot="prepend">上</template>
                        </el-input>
                      </div>
                    </el-form-item>
                  </div>
                  <div class="effective-left-box">
                    <el-form-item prop="effectiveCoverageLeft">
                      <div class="common-input-box">
                        <el-input
                          class="input-outerborder-primary"
                          size="small"
                          @change="value => inputChange('left', value)"
                          v-model="bboxForm.effectiveCoverageLeft">
                          <template slot="prepend">左</template>
                        </el-input>
                      </div>
                    </el-form-item>
                  </div>
                  <div class="effective-bottom-box">
                    <el-form-item prop="effectiveCoverageDown">
                      <div class="common-input-box">
                        <el-input
                          class="input-outerborder-primary"
                          size="small"
                          @change="value => inputChange('bottom', value)"
                          v-model="bboxForm.effectiveCoverageDown">
                          <template slot="prepend">下</template>
                        </el-input>
                      </div>
                    </el-form-item>
                  </div>
                  <div class="effective-right-box">
                    <el-form-item prop="effectiveCoverageRight">
                      <div class="common-input-box">
                        <el-input
                          class="input-outerborder-primary"
                          size="small"
                          @change="value => inputChange('right', value)"
                          v-model="bboxForm.effectiveCoverageRight">
                          <template slot="prepend">右</template>
                        </el-input>
                      </div>
                    </el-form-item>
                  </div>
                </el-form>
              </div>
            </div>
            <div
              class="senior-params-box"
              v-if="isServiceFormVisible()">
              <div class="senior-title-box">
                <div>引擎相关校正</div>
                <div class="icon-box">
                  <i
                    v-if="isParamsContentVisible"
                    class="el-icon-arrow-up" />
                  <i
                    v-else
                    class="el-icon-arrow-down" />
                </div>
              </div>
              <div
                class="senior-param-content-box"
                v-if="isParamsContentVisible">
                <div class="item-box">
                  <div class="common-checkbox-box">
                    <el-checkbox
                      class="checkbox-primary"
                      v-model="seniorParams.revertResX">
                      资源索引水平翻转
                    </el-checkbox>
                  </div>
                  <div class="common-checkbox-box">
                    <el-checkbox
                      class="checkbox-primary"
                      v-model="seniorParams.revertResY">
                      资源索引垂直翻转
                    </el-checkbox>
                  </div>
                </div>
                <div class="item-box">
                  <div class="common-checkbox-box">
                    <el-checkbox
                      class="checkbox-primary"
                      v-model="seniorParams.revertU">
                      资源内容水平翻转
                    </el-checkbox>
                  </div>
                  <div class="common-checkbox-box">
                    <el-checkbox
                      class="checkbox-primary"
                      v-model="seniorParams.revertV">
                      资源内容垂直翻转
                    </el-checkbox>
                  </div>
                </div>
                <div class="item-box">
                  <div class="senior-label-box">根节点索引偏移：</div>
                </div>
                <div class="item-box">
                  <div class="common-input-box">
                    <div>X：</div>
                    <el-input
                      size="small"
                      class="input-outerborder-primary"
                      v-model="seniorParams.biasRootX" />
                  </div>
                  <div class="common-input-box">
                    <div>Y：</div>
                    <el-input
                      size="small"
                      class="input-outerborder-primary"
                      v-model="seniorParams.biasRootY" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="currMapServiceInfo.layerResType === 'height'"
            class="occupation-map-box">
            <div class="common-empty-box">
              <bj-empty
                :image="require('@/assets/img/no-data.png')"
                class="empty-page">
                <template slot="description">
                  <div class="text-box">
                    高程影像无法直接预览，需在场景中与其他WMTS底图叠加显示
                  </div>
                </template>
              </bj-empty>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="isServiceFormVisible()"
        class="common-button-box">
        <el-button
          class="normal-btn primary-ang-btn gr8"
          size="small"
          @click="previewMapService">
          预览
        </el-button>
        <el-button
          type="primary"
          class="primary-btn primary-ang-btn"
          size="small"
          @click="submitMapService">
          确定
        </el-button>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import * as turf from '@turf/turf'

import DragDialog from '@/components/CustomDragDialog.vue'
import MapServiceList from './MapServiceList.vue'
import NewService from './NewServiceCreate.vue'

import BBox from '@/utils/bbox'

import {
  createServeByCapabilityService,
  modifyWmtsTemplate,
  modifyWmtsIntrinsicTemplate
} from '@/service/interface'

const mapboxgl = window.mapboxgl
const MapboxLanguage = window.MapboxLanguage
const MapboxGeocoder = window.MapboxGeocoder
// prettier-ignore
mapboxgl.accessToken = "pk.eyJ1IjoiY2htMTc4MSIsImEiOiJjaXI0YWk3a3QwMWx5ZnBubTFuY3d2enZvIn0.zDEUyiEq9gGb69B8qki9Tg";

export default {
  data() {
    // 有效区域验证
    const validTopRule = (rule, value, callback) => {
      if (!this.bboxForm.enableCoverage) return callback()
      if (Number(value) > this.bboxForm.effectiveCoverageDown) {
        return callback()
      } else {
        callback(new Error('上有效区应大于下有效区'))
      }
    }
    const validBottomRule = (rule, value, callback) => {
      if (!this.bboxForm.enableCoverage) return callback()
      if (Number(value) < this.bboxForm.effectiveCoverageTop) {
        return callback()
      } else {
        callback(new Error('下有效区应小于上有效区'))
      }
    }
    const validLeftRule = (rule, value, callback) => {
      if (!this.bboxForm.enableCoverage) return callback()
      if (Number(value) < this.bboxForm.effectiveCoverageRight) {
        return callback()
      } else {
        callback(new Error('左有效区应小于右有效区'))
      }
    }
    const validRightRule = (rule, value, callback) => {
      if (!this.bboxForm.enableCoverage) return callback()
      if (Number(value) > this.bboxForm.effectiveCoverageLeft) {
        return callback()
      } else {
        callback(new Error('右有效区应大于左有效区'))
      }
    }

    return {
      // 当前模式
      // serviceList：服务列表模式，查看服务列表和新建地图
      // createService: 创建服务模式，新建服务
      // editService：编辑新服务模式，编辑服务
      currMode: 'serviceList',

      // 当前选中的地图服务
      currMapServiceInfo: {},

      isParamsContentVisible: true,
      seniorParams: {
        revertResX: false,
        revertResY: true,
        revertU: false,
        revertV: false,
        biasRootX: 0,
        biasRootY: 0
      },

      bboxForm: {
        enableCoverage: false,
        effectiveCoverageTop: '',
        effectiveCoverageDown: '',
        effectiveCoverageLeft: '',
        effectiveCoverageRight: ''
      },

      rules: {
        effectiveCoverageTop: [
          { required: true, message: '请输入', trigger: 'blur' },
          {
            pattern:
              /^(-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/,
            message: '请输入有效值'
          },
          { validator: validTopRule }
        ],
        effectiveCoverageDown: [
          { required: true, message: '请输入', trigger: 'blur' },
          {
            pattern:
              /^(-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/,
            message: '请输入有效值'
          },
          { validator: validBottomRule }
        ],
        effectiveCoverageLeft: [
          { required: true, message: '请输入', trigger: 'blur' },
          {
            pattern:
              /^(-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/,
            message: '请输入有效值'
          },
          { validator: validLeftRule }
        ],
        effectiveCoverageRight: [
          { required: true, message: '请输入', trigger: 'blur' },
          {
            pattern:
              /^(-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/,
            message: '请输入有效值'
          },
          { validator: validRightRule }
        ]
      },

      footerBtn: ['cancel', 'submit']
    }
  },
  components: {
    DragDialog,
    MapServiceList,
    NewService
  },
  props: {
    visible: Boolean,
    configWmts: Function,
    cancelCreate: Function
  },
  methods: {
    updateCurrMode(currMode) {
      this.currMode = currMode

      if (currMode === 'serviceList') {
        this.footerBtn = ['cancel', 'submit']
      } else {
        this.footerBtn = []
      }

      if (currMode === 'createService') {
        this.resetMap()
        this.currMapServiceInfo = {}
        this.resetSeniorParams()
      }

      if (currMode === 'editService') {
        this.resetBBoxForm()
        this.initSeniorParams()

        let domRef = this.$refs.newService
        domRef.initServiceForm()

        this.$nextTick(() => {
          this.map.resize()
        })
      }
    },
    previewMapService() {
      let fmtStr_Web = this.$refs.newService.getWebResUrl()

      if (!fmtStr_Web) {
        this.$message.warning('请先输入瓦片集URL再预览')
        return
      }

      let layerInfo = { fmtStr_Web }
      this.addLayer(layerInfo, 'bbox-area')

      this.map.resize()
    },
    submitMapService() {
      let params = this.$refs.newService.getServiceParams()
      // prettier-ignore
      let { revertResX, revertResY, revertU, revertV, biasRootX, biasRootY } = this.seniorParams;
      params.revertResX = revertResX
      params.revertResY = revertResY
      params.revertU = revertU
      params.revertV = revertV
      params.biasRootXY = `${biasRootX},${biasRootY}`

      if (this.currMode === 'createService') {
        createServeByCapabilityService(params).then(response => {
          if (response.isSuccess) {
            let serviceId = response.data

            let domRef = this.$refs.mapServiceList
            domRef.updateMapServiceList(serviceId).then(() => {
              this.updateCurrMode('serviceList')

              let editServiceDomRef = this.$refs.newService
              editServiceDomRef.clearServiceForm()
              this.resetSeniorParams()

              this.$nextTick(() => {
                domRef.scrollToActiveItem()
              })
            })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      } else {
        let serviceInfo = this.currMapServiceInfo
        params.wmtsTemplateId = serviceInfo.wmtsTemplateId
        if (serviceInfo.isIntrinsic) {
          modifyWmtsIntrinsicTemplate(params).then(response => {
            if (response.isSuccess) {
              let domRef = this.$refs.mapServiceList

              // prettier-ignore
              domRef.updateMapServiceList(serviceInfo.wmtsTemplateId).then(() => {
                this.updateCurrMode("serviceList");

                let editServiceDomRef = this.$refs.newService;
                editServiceDomRef.clearServiceForm();
                this.resetSeniorParams();

                this.$nextTick(() => {
                  domRef.scrollToActiveItem();
                });

                this.$message.success("更新服务成功");
              });
            } else {
              this.$message.error(response.errMsg)
            }
          })
        } else {
          modifyWmtsTemplate(params).then(response => {
            if (response.isSuccess) {
              let domRef = this.$refs.mapServiceList

              // prettier-ignore
              domRef.updateMapServiceList(serviceInfo.wmtsTemplateId).then(() => {
                this.updateCurrMode("serviceList");

                let editServiceDomRef = this.$refs.newService;
                editServiceDomRef.clearServiceForm();
                this.resetSeniorParams();

                this.$nextTick(() => {
                  domRef.scrollToActiveItem();
                });
                
                this.$message.success("更新服务成功");
              });
            } else {
              this.$message.error(response.errMsg)
            }
          })
        }
      }
    },
    updateCurrMapServiceInfo(currMapServiceInfo, isForceUpdate) {
      let selServiceId = currMapServiceInfo.wmtsTemplateId
      let currServiceId = this.currMapServiceInfo.wmtsTemplateId
      if (selServiceId === currServiceId && !isForceUpdate) return

      this.currMapServiceInfo = this.formatMapServiceInfo(currMapServiceInfo)

      if (this.currMapServiceInfo.layerResType === 'height') return

      this.addLayer(this.currMapServiceInfo, 'bbox-area')

      this.bbox && this.bbox.reset()
      this.setCurrMapServiceEffectiveCoverage()
      if (this.currMapServiceInfo.enableCoverage) {
        this.bbox.editFlag = true
        this.bbox.start()
      }
    },
    submit() {
      let configInfo = {
        templateId: this.currMapServiceInfo.wmtsTemplateId,
        serviceName: this.currMapServiceInfo.serviceName,
        enableCoverage: this.bboxForm.enableCoverage,
        effectiveCoverageTop: this.bboxForm.effectiveCoverageTop,
        effectiveCoverageDown: this.bboxForm.effectiveCoverageDown,
        effectiveCoverageLeft: this.bboxForm.effectiveCoverageLeft,
        effectiveCoverageRight: this.bboxForm.effectiveCoverageRight
      }
      this.configWmts(configInfo)

      this.currMode = 'serviceList'
      this.resetMap()
      this.resetBBoxForm()

      let layers = this.map.getStyle().layers
      let layerList = layers.filter(el => !el.id.includes('bbox'))
      layerList.forEach(item => {
        this.map.removeLayer(item.id)
        this.map.removeSource(item.source)
      })
      this.map = null
      this.bbox = null

      this.resetSeniorParams()
    },
    cancel() {
      this.currMode = 'serviceList'
      this.currMapServiceInfo = {}
      this.resetMap()
      this.resetBBoxForm()

      let layers = this.map.getStyle().layers
      let layerList = layers.filter(el => !el.id.includes('bbox'))
      layerList.forEach(item => {
        this.map.removeLayer(item.id)
        this.map.removeSource(item.source)
      })
      this.map = null
      this.bbox = null

      this.resetSeniorParams()
      this.cancelCreate()
    },
    addLayer(layerInfo, beneathLayerId) {
      if (!this.map) {
        this.initMap()
        beneathLayerId = ''
      }

      if (this.map.getStyle()) {
        let layers = this.map.getStyle().layers
        let layer = layers.filter(el => !el.id.includes('bbox'))
        if (layer.length) {
          this.map.removeLayer(layer[0].id)
          this.map.removeSource(layer[0].id)
        }

        let find = layers.find(el => el.id.includes('bbox'))
        if (!find) {
          beneathLayerId = ''
        }
      }

      this.setCenterAndZoomByUrl(layerInfo.fmtStr_Web)

      this.map.addLayer(
        {
          id: layerInfo.wmtsTemplateId ? layerInfo.wmtsTemplateId : 'basemap',
          type: 'raster',
          source: {
            type: 'raster',
            tiles: [layerInfo.fmtStr_Web],
            tileSize: 256
          },
          paint: {}
        },
        beneathLayerId
      )
    },
    initMap() {
      let mapOption = {
        container: 'mapbox-map',
        center: [108.992513, 37.72948],
        zoom: 2
      }
      this.map = new mapboxgl.Map(mapOption)

      this.map.addControl(new MapboxLanguage({ defaultLanguage: 'zh' }))

      let accessToken = mapboxgl.accessToken
      let mapboxGeocoder = new MapboxGeocoder({ accessToken, mapboxgl })
      this.map.addControl(mapboxGeocoder, 'top-left')

      this.map.on('load', this.onMapboxLoaded)
    },
    onMapboxLoaded() {
      if (!this.map) return

      this.map.resize()
      if (!this.bbox) {
        this.bbox = new BBox(this.map, this.getBBox)
      }
      this.setCurrMapServiceEffectiveCoverage()
      if (this.currMapServiceInfo.enableCoverage) {
        this.bbox.editFlag = true
        this.bbox.start()
      }
    },
    getBBox(geometry) {
      let bbox = turf.bbox(geometry)
      this.bboxForm.effectiveCoverageLeft = Number(bbox[0]).toFixed(6)
      this.bboxForm.effectiveCoverageDown = Number(bbox[1]).toFixed(6)
      this.bboxForm.effectiveCoverageRight = Number(bbox[2]).toFixed(6)
      this.bboxForm.effectiveCoverageTop = Number(bbox[3]).toFixed(6)
    },
    checkboxChange(value) {
      if (value) {
        this.bbox.editFlag = false
        this.bbox.start()
      } else {
        this.resetBBoxForm()
      }
    },
    resetBBoxForm() {
      this.bbox && this.bbox.reset()
      this.bboxForm.enableCoverage = false
      this.bboxForm.effectiveCoverageLeft = ''
      this.bboxForm.effectiveCoverageDown = ''
      this.bboxForm.effectiveCoverageRight = ''
      this.bboxForm.effectiveCoverageTop = ''
    },
    inputChange(type, value) {
      this.$refs.bboxForm.validate((bool, object) => {
        if (bool) {
          this.bbox.updateGeometry(type, value)
        }
      })
    },
    setCenterAndZoomByUrl(serviceUrl) {
      if (serviceUrl.includes('img_c')) {
        this.map.setCenter([109.150767, 76.634956])
      } else {
        this.map.setCenter([108.992513, 37.72948])
      }
      this.map.setZoom(2)
    },
    setCurrMapServiceEffectiveCoverage() {
      let bboxForm = {
        enableCoverage: this.currMapServiceInfo.enableCoverage,
        effectiveCoverageTop: this.currMapServiceInfo.effectiveCoverageTop,
        effectiveCoverageDown: this.currMapServiceInfo.effectiveCoverageDown,
        effectiveCoverageLeft: this.currMapServiceInfo.effectiveCoverageLeft,
        effectiveCoverageRight: this.currMapServiceInfo.effectiveCoverageRight
      }
      this.bboxForm = bboxForm

      if (bboxForm.enableCoverage) {
        let bbox = [
          Number(bboxForm.effectiveCoverageLeft),
          Number(bboxForm.effectiveCoverageDown),
          Number(bboxForm.effectiveCoverageRight),
          Number(bboxForm.effectiveCoverageTop)
        ]
        this.bbox && this.bbox.updateBBoxPolygon(bbox)
      }
    },
    resetMap() {
      this.resetBBoxForm()

      if (this.map.getStyle()) {
        let layers = this.map.getStyle().layers
        let layerList = layers.filter(el => !el.id.includes('bbox'))
        if (layerList.length) {
          layerList.forEach(item => {
            this.map.removeLayer(item.id)
            this.map.removeSource(item.source)
          })
        }
      }
    },
    initSeniorParams() {
      // prettier-ignore
      let { revertResX, revertResY, revertU, revertV, biasRootX, biasRootY } = this.currMapServiceInfo;
      this.seniorParams = {
        revertResX,
        revertResY,
        revertU,
        revertV,
        biasRootX,
        biasRootY
      }
    },
    resetSeniorParams() {
      this.seniorParams = {
        revertResX: false,
        revertResY: true,
        revertU: false,
        revertV: false,
        biasRootX: 0,
        biasRootY: 0
      }
    },
    formatMapServiceInfo(currMapServiceInfo) {
      let mapServiceInfo = {
        wmtsTemplateId: currMapServiceInfo.wmtsTemplateId,
        capabilityType: currMapServiceInfo.capabilityType,
        capabilityAddr: currMapServiceInfo.capabilityAddr,
        CapabilityInfo: currMapServiceInfo.CapabilityInfo,
        isIntrinsic: currMapServiceInfo.isIntrinsic,
        serviceName: currMapServiceInfo.serviceName,
        fmtStr_Web: currMapServiceInfo.fmtStr_Web,
        fmtStr_App: currMapServiceInfo.fmtStr_App
          ? currMapServiceInfo.fmtStr_App
          : currMapServiceInfo.fmtStr_Web,
        worCRS: currMapServiceInfo.worCRS,
        lodMin: currMapServiceInfo.lodMin,
        lodMax: currMapServiceInfo.lodMax,
        revertResX: currMapServiceInfo.revertResX,
        revertResY: currMapServiceInfo.revertResY,
        revertU: currMapServiceInfo.revertU,
        revertV: currMapServiceInfo.revertV,
        enableCoverage: currMapServiceInfo.enableCoverage,
        effectiveCoverageTop: currMapServiceInfo.effectiveCoverageTop,
        effectiveCoverageDown: currMapServiceInfo.effectiveCoverageDown,
        effectiveCoverageLeft: currMapServiceInfo.effectiveCoverageLeft,
        effectiveCoverageRight: currMapServiceInfo.effectiveCoverageRight
      }

      let {
        projFlatBase,
        projFlatSize,
        projFlatRootNum,
        biasRootXY,
        layerResType,
        picTransp
      } = currMapServiceInfo

      mapServiceInfo.projFlatBaseX = Number(projFlatBase.split(',')[0])
      mapServiceInfo.projFlatBaseY = Number(projFlatBase.split(',')[1])
      mapServiceInfo.projFlatSizeX = Number(projFlatSize.split(',')[0])
      mapServiceInfo.projFlatSizeY = Number(projFlatSize.split(',')[1])
      mapServiceInfo.projFlatRootNumX = Number(projFlatRootNum.split(',')[0])
      mapServiceInfo.projFlatRootNumY = Number(projFlatRootNum.split(',')[1])
      mapServiceInfo.biasRootX = Number(biasRootXY.split(',')[0])
      mapServiceInfo.biasRootY = Number(biasRootXY.split(',')[1])

      if (layerResType === 'height') {
        mapServiceInfo.layerResType = 'height'
      } else if (layerResType === 'imgpic' && picTransp === 0) {
        mapServiceInfo.layerResType = 'imgpic_img'
        mapServiceInfo.picTransp = 0
      } else {
        mapServiceInfo.layerResType = 'imgpic_vec'
        mapServiceInfo.picTransp = 1
      }

      return mapServiceInfo
    },
    isNewServiceVisible() {
      let currMode = this.currMode
      let visibleModes = ['createService', 'editService']
      if (visibleModes.includes(currMode)) {
        return true
      } else {
        return false
      }
    },
    isCoverageVisible() {
      let currMode = this.currMode
      if (currMode === 'serviceList') {
        return true
      } else {
        return false
      }
    },
    isServiceFormVisible() {
      let currMode = this.currMode
      if (currMode !== 'serviceList') {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.input-outerborder-primary {
  :deep(.el-input-group__prepend) {
    background-color: var(--wmts-mapview-effective-bg-color);
    border-color: var(--wmts-mapview-effective-border-color);
    color: var(--wmts-mapview-effective-prepend-color);
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    padding: 0 13px;
  }
  :deep(.el-input__inner) {
    color: var(--wmts-mapview-effective-color);
    border-color: var(--wmts-mapview-effective-border-color);
    height: 30px;
    line-height: 30px;
    border-top-right-radius: 8px !important;
    border-bottom-right-radius: 8px !important;
    width: 64px;
  }
}
:deep(.dialog-content) {
  padding: 10px 20px !important;
}
.wmts-map-box {
  color: var(--wmts-default-color);

  .service-box {
    display: flex;
    justify-content: space-between;

    .service-preview-box {
      width: 49%;
      text-align: left;

      .header {
        height: 20px;
        line-height: 20px;
        margin: 6px 0px;
        margin-bottom: 14px;
        border-left: 4px solid var(--base-primary-bgColor);
        padding-left: 8px;
      }

      .content-box {
        display: flex;
        flex-direction: column;
        height: calc(100% - 35px);
        margin-top: 10px;
        border: 1px solid var(--wmts-mapview-border-color);
        border-radius: 4px;
        background-color: var(--wmts-mapview-bg-color);

        .map-container {
          position: relative;
          flex-grow: 1;
          min-height: 320px;
          border-radius: 8px;
          border: 1px solid var(--wmts-mapview-map-border-color);
        }

        .service-form-box {
          padding: 15px;

          .common-checkbox-box {
            .el-checkbox {
              color: var(--default-color);
            }
          }

          .effective-coverage-input-box {
            position: relative;
            height: 270px;

            .compass-box {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              height: 120px;
              width: 120px;
              background: var(--wmts-mapview-compass-bg-color);
              border-radius: 50%;
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
              .compass-outer-circle {
                border-radius: 50%;
                margin-top: 8px;

                img {
                  width: 84px;
                  height: 84px;
                  object-fit: contain;
                }
              }
            }

            .common-input-box {
              width: 104px;

              :deep(.el-input-group__prepend) {
                border-top-left-radius: 8px;
                border-bottom-left-radius: 8px;
              }
            }

            .effective-top-box {
              position: absolute;
              top: 32px;
              left: 50%;
              transform: translateX(-50%);

              /deep/ .el-form-item__error {
                width: 145px;
                top: 0px;
                left: 107px;
                line-height: 25px;
                text-align: left;
              }
            }

            .effective-left-box {
              position: absolute;
              top: 120px;
              left: 92px;

              /deep/ .el-form-item__error {
                width: 145px;
                top: 24px;
                left: 50px;
                line-height: 25px;
                text-align: left;
              }
            }

            .effective-bottom-box {
              position: absolute;
              bottom: 0;
              left: 50%;
              transform: translateX(-50%);

              /deep/ .el-form-item__error {
                width: 145px;
                top: 0px;
                left: 107px;
                line-height: 25px;
                text-align: left;
              }
            }

            .effective-right-box {
              position: absolute;
              top: 120px;
              right: 92px;

              /deep/ .el-form-item__error {
                width: 145px;
                top: 24px;
                left: 50px;
                line-height: 25px;
                text-align: left;
              }
            }
          }
        }

        .senior-params-box {
          padding: 15px;

          .senior-title-box {
            display: flex;

            .icon-box {
              margin-left: 5px;
              cursor: pointer;
            }
          }

          .senior-param-content-box {
            .item-box {
              display: flex;
              margin: 10px auto;
              line-height: 32px;

              .common-checkbox-box {
                margin: 0px 35px;
                .el-checkbox {
                  color: var(--default-color);
                }
              }

              .senior-label-box {
                width: 135px;
                margin-left: 35px;
              }

              .common-input-box {
                display: flex;
                margin-left: 35px;
                width: 104px;

                &:last-child {
                  margin-left: 30px;
                }
              }
            }
          }
        }
      }

      .occupation-map-box {
        height: calc(100% - 30px);
        border: 1px solid var(--base-border-dark-color14);
      }
    }
  }

  .common-button-box {
    width: calc(100% + 30px);
    margin-top: 11px;
    margin-left: -20px;
    border-top: 1px solid var(--base-border-dark-color14);
    padding-top: 10px;
    text-align: right;

    .el-button {
      // font-size: 12px;
      margin-left: 0px;
    }

    .el-button--default {
      // background: transparent;
      // border-color: var(--dialog-footer-border-color);
    }
  }
}
</style>
